import request from '@/router/axios';

export function fetchOrganizationTagList(query) {
  return request({
    url: '/admin/admin/organization-tag/page',
    method: 'get',
    params: query
  })
}

export function fetchAllOrganizationTagList() {
  return request({
    url: '/admin/admin/member/organization-tag/all',
    method: 'get',
  })
}

export function addOrganizationTag(tagName) {
  return request({
    url: `/admin/admin/organization-tag`,
    method: 'post',
    params: { tagName },
  })
}

export function editOrganizationTag(id, tagName) {
  return request({
    url: `/admin/admin/organization-tag/${id}`,
    method: 'put',
    params: { tagName },
  })
}

export function deleteOrganizationTag(id) {
  return request({
    url: `/admin/admin/organization-tag/${id}`,
    method: 'delete',
  })
}
